var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasHistory)?_c('a',{staticClass:"back__button",on:{"click":function($event){$event.preventDefault();return _vm.routerBack()}}},[_c('i',{staticClass:"pi pi-angle-left"}),_vm._v("\n    Back\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }